import type { LanguageCode } from '../types/entryRules.types';

export interface CountryOption {
  code: string;
  ru: string;
  kz: string;
  en: string;
}

// Source of truth: shared country/shortcode list used by the Step2Travel mobile app.
// Keep this list in sync with the mobile app so a country code selected here renders
// the same country on mobile. Codes are ISO 3166-1 alpha-2.
export const COUNTRIES: CountryOption[] = [
  { code: 'AF', ru: 'Афганистан', kz: 'Ауғанстан', en: 'Afghanistan' },
  { code: 'AX', ru: 'Аландские острова', kz: 'Аланд аралдары', en: 'Åland Islands' },
  { code: 'AL', ru: 'Албания', kz: 'Албания', en: 'Albania' },
  { code: 'DZ', ru: 'Алжир', kz: 'Алжир', en: 'Algeria' },
  { code: 'AS', ru: 'Американское Самоа', kz: 'Америкалық Самоа', en: 'American Samoa' },
  { code: 'AD', ru: 'Андорра', kz: 'Андорра', en: 'Andorra' },
  { code: 'AO', ru: 'Ангола', kz: 'Ангола', en: 'Angola' },
  { code: 'AI', ru: 'Ангилья', kz: 'Ангилья', en: 'Anguilla' },
  { code: 'AG', ru: 'Антигуа и Барбуда', kz: 'Антигуа және Барбуда', en: 'Antigua and Barbuda' },
  { code: 'AR', ru: 'Аргентина', kz: 'Аргентина', en: 'Argentina' },
  { code: 'AM', ru: 'Армения', kz: 'Армения', en: 'Armenia' },
  { code: 'AW', ru: 'Аруба', kz: 'Аруба', en: 'Aruba' },
  { code: 'AU', ru: 'Австралия', kz: 'Австралия', en: 'Australia' },
  { code: 'AT', ru: 'Австрия', kz: 'Австрия', en: 'Austria' },
  { code: 'AZ', ru: 'Азербайджан', kz: 'Әзірбайжан', en: 'Azerbaijan' },
  { code: 'BS', ru: 'Багамы', kz: 'Багам аралдары', en: 'Bahamas' },
  { code: 'BH', ru: 'Бахрейн', kz: 'Бахрейн', en: 'Bahrain' },
  { code: 'BD', ru: 'Бангладеш', kz: 'Бангладеш', en: 'Bangladesh' },
  { code: 'BB', ru: 'Барбадос', kz: 'Барбадос', en: 'Barbados' },
  { code: 'BY', ru: 'Беларусь', kz: 'Беларусь', en: 'Belarus' },
  { code: 'BE', ru: 'Бельгия', kz: 'Бельгия', en: 'Belgium' },
  { code: 'BZ', ru: 'Белиз', kz: 'Белиз', en: 'Belize' },
  { code: 'BJ', ru: 'Бенин', kz: 'Бенин', en: 'Benin' },
  { code: 'BM', ru: 'Бермуды', kz: 'Бермуд аралдары', en: 'Bermuda' },
  { code: 'BT', ru: 'Бутан', kz: 'Бутан', en: 'Bhutan' },
  { code: 'BO', ru: 'Боливия', kz: 'Боливия', en: 'Bolivia' },
  { code: 'BQ', ru: 'Бонэйр, Синт-Эстатиус и Саба', kz: 'Кариб Нидерландысы', en: 'Bonaire, Sint Eustatius and Saba' },
  { code: 'BA', ru: 'Босния и Герцеговина', kz: 'Босния және Герцеговина', en: 'Bosnia and Herzegovina' },
  { code: 'BW', ru: 'Ботсвана', kz: 'Ботсвана', en: 'Botswana' },
  { code: 'BR', ru: 'Бразилия', kz: 'Бразилия', en: 'Brazil' },
  { code: 'IO', ru: 'Британская территория в Индийском океане', kz: 'Үнді мұхитындағы Британ аймағы', en: 'British Indian Ocean Territory' },
  { code: 'BN', ru: 'Бруней', kz: 'Бруней', en: 'Brunei Darussalam' },
  { code: 'BG', ru: 'Болгария', kz: 'Болгария', en: 'Bulgaria' },
  { code: 'BF', ru: 'Буркина-Фасо', kz: 'Буркина-Фасо', en: 'Burkina Faso' },
  { code: 'BI', ru: 'Бурунди', kz: 'Бурунди', en: 'Burundi' },
  { code: 'KH', ru: 'Камбоджа', kz: 'Камбоджа', en: 'Cambodia' },
  { code: 'CM', ru: 'Камерун', kz: 'Камерун', en: 'Cameroon' },
  { code: 'CA', ru: 'Канада', kz: 'Канада', en: 'Canada' },
  { code: 'CV', ru: 'Кабо-Верде', kz: 'Кабо-Верде', en: 'Cape Verde' },
  { code: 'KY', ru: 'Острова Кайман', kz: 'Кайман аралдары', en: 'Cayman Islands' },
  { code: 'CF', ru: 'ЦАР', kz: 'Орталық Африка Республикасы', en: 'Central African Republic' },
  { code: 'TD', ru: 'Чад', kz: 'Чад', en: 'Chad' },
  { code: 'CL', ru: 'Чили', kz: 'Чили', en: 'Chile' },
  { code: 'CX', ru: 'Остров Рождества', kz: 'Рождество аралы', en: 'Christmas Island' },
  { code: 'CC', ru: 'Кокосовые острова', kz: 'Кокос (Килинг) аралдары', en: 'Cocos (Keeling) Islands' },
  { code: 'CO', ru: 'Колумбия', kz: 'Колумбия', en: 'Colombia' },
  { code: 'KM', ru: 'Коморы', kz: 'Комор аралдары', en: 'Comoros' },
  { code: 'CK', ru: 'Острова Кука', kz: 'Кук аралдары', en: 'Cook Islands' },
  { code: 'CR', ru: 'Коста-Рика', kz: 'Коста-Рика', en: 'Costa Rica' },
  { code: 'CI', ru: 'Кот-д’Ивуар', kz: 'Кот-д’Ивуар', en: 'Cote d\'Ivoire' },
  { code: 'HR', ru: 'Хорватия', kz: 'Хорватия', en: 'Croatia' },
  { code: 'CU', ru: 'Куба', kz: 'Куба', en: 'Cuba' },
  { code: 'CW', ru: 'Кюрасао', kz: 'Кюрасао', en: 'Curaçao' },
  { code: 'CY', ru: 'Кипр', kz: 'Кипр', en: 'Cyprus' },
  { code: 'CZ', ru: 'Чехия', kz: 'Чех Республикасы', en: 'Czech Republic' },
  { code: 'CD', ru: 'Демократическая Республика Конго', kz: 'Конго', en: 'Democratic Republic of the Congo' },
  { code: 'DK', ru: 'Дания', kz: 'Дания', en: 'Denmark' },
  { code: 'DJ', ru: 'Джибути', kz: 'Джибути', en: 'Djibouti' },
  { code: 'DM', ru: 'Доминика', kz: 'Доминика', en: 'Dominica' },
  { code: 'DO', ru: 'Доминиканская Республика', kz: 'Доминикан Республикасы', en: 'Dominican Republic' },
  { code: 'EC', ru: 'Эквадор', kz: 'Эквадор', en: 'Ecuador' },
  { code: 'EG', ru: 'Египет', kz: 'Мысыр', en: 'Egypt' },
  { code: 'SV', ru: 'Сальвадор', kz: 'Сальвадор', en: 'El Salvador' },
  { code: 'GQ', ru: 'Экваториальная Гвинея', kz: 'Экваторлық Гвинея', en: 'Equatorial Guinea' },
  { code: 'ER', ru: 'Эритрея', kz: 'Эритрея', en: 'Eritrea' },
  { code: 'EE', ru: 'Эстония', kz: 'Эстония', en: 'Estonia' },
  { code: 'SZ', ru: 'Эсватини', kz: 'Свазиленд', en: 'Eswatini' },
  { code: 'ET', ru: 'Эфиопия', kz: 'Эфиопия', en: 'Ethiopia' },
  { code: 'FK', ru: 'Фолклендские острова', kz: 'Фолкленд аралдары', en: 'Falkland Islands (Malvinas)' },
  { code: 'FO', ru: 'Фареры', kz: 'Фарер аралдары', en: 'Faroe Islands' },
  { code: 'FJ', ru: 'Фиджи', kz: 'Фиджи', en: 'Fiji' },
  { code: 'FI', ru: 'Финляндия', kz: 'Финляндия', en: 'Finland' },
  { code: 'FR', ru: 'Франция', kz: 'Франция', en: 'France' },
  { code: 'GF', ru: 'Гвиана', kz: 'Француз Гвианасы', en: 'French Guiana' },
  { code: 'PF', ru: 'Французская Полинезия', kz: 'Француз Полинезиясы', en: 'French Polynesia' },
  { code: 'GA', ru: 'Габон', kz: 'Габон', en: 'Gabon' },
  { code: 'GE', ru: 'Грузия', kz: 'Грузия', en: 'Georgia' },
  { code: 'DE', ru: 'Германия', kz: 'Германия', en: 'Germany' },
  { code: 'GH', ru: 'Гана', kz: 'Гана', en: 'Ghana' },
  { code: 'GI', ru: 'Гибралтар', kz: 'Гибралтар', en: 'Gibraltar' },
  { code: 'GR', ru: 'Греция', kz: 'Грекия', en: 'Greece' },
  { code: 'GL', ru: 'Гренландия', kz: 'Гренландия', en: 'Greenland' },
  { code: 'GD', ru: 'Гренада', kz: 'Гренада', en: 'Grenada' },
  { code: 'GP', ru: 'Гваделупа', kz: 'Гваделупа', en: 'Guadeloupe' },
  { code: 'GU', ru: 'Гуам', kz: 'Гуам', en: 'Guam' },
  { code: 'GT', ru: 'Гватемала', kz: 'Гватемала', en: 'Guatemala' },
  { code: 'GG', ru: 'Гернси', kz: 'Гернси', en: 'Guernsey' },
  { code: 'GN', ru: 'Гвинея', kz: 'Гвинея', en: 'Guinea' },
  { code: 'GW', ru: 'Гвинея-Бисау', kz: 'Гвинея-Бисау', en: 'Guinea-Bissau' },
  { code: 'GY', ru: 'Гайана', kz: 'Гайана', en: 'Guyana' },
  { code: 'HT', ru: 'Гаити', kz: 'Гаити', en: 'Haiti' },
  { code: 'VA', ru: 'Ватикан', kz: 'Ватикан', en: 'Holy See (Vatican City State)' },
  { code: 'HN', ru: 'Гондурас', kz: 'Гондурас', en: 'Honduras' },
  { code: 'HK', ru: 'Гонконг', kz: 'Гонконг', en: 'Hong Kong' },
  { code: 'HU', ru: 'Венгрия', kz: 'Венгрия', en: 'Hungary' },
  { code: 'IS', ru: 'Исландия', kz: 'Исландия', en: 'Iceland' },
  { code: 'IN', ru: 'Индия', kz: 'Үндістан', en: 'India' },
  { code: 'ID', ru: 'Индонезия', kz: 'Индонезия', en: 'Indonesia' },
  { code: 'IQ', ru: 'Ирак', kz: 'Ирак', en: 'Iraq' },
  { code: 'IE', ru: 'Ирландия', kz: 'Ирландия', en: 'Ireland' },
  { code: 'IR', ru: 'Иран', kz: 'Иран', en: 'Islamic Republic of Iran' },
  { code: 'IM', ru: 'Остров Мэн', kz: 'Мэн аралы', en: 'Isle of Man' },
  { code: 'IL', ru: 'Израиль', kz: 'Израиль', en: 'Israel' },
  { code: 'IT', ru: 'Италия', kz: 'Италия', en: 'Italy' },
  { code: 'JM', ru: 'Ямайка', kz: 'Ямайка', en: 'Jamaica' },
  { code: 'JP', ru: 'Япония', kz: 'Жапония', en: 'Japan' },
  { code: 'JE', ru: 'Джерси', kz: 'Джерси', en: 'Jersey' },
  { code: 'JO', ru: 'Иордания', kz: 'Иордания', en: 'Jordan' },
  { code: 'KZ', ru: 'Казахстан', kz: 'Қазақстан', en: 'Kazakhstan' },
  { code: 'KE', ru: 'Кения', kz: 'Кения', en: 'Kenya' },
  { code: 'KI', ru: 'Кирибати', kz: 'Кирибати', en: 'Kiribati' },
  { code: 'XK', ru: 'Косово', kz: 'Косово', en: 'Kosovo' },
  { code: 'KW', ru: 'Кувейт', kz: 'Кувейт', en: 'Kuwait' },
  { code: 'KG', ru: 'Киргизия', kz: 'Қырғызстан', en: 'Kyrgyzstan' },
  { code: 'LA', ru: 'Лаос', kz: 'Лаос', en: 'Lao People\'s Democratic Republic' },
  { code: 'LV', ru: 'Латвия', kz: 'Латвия', en: 'Latvia' },
  { code: 'LB', ru: 'Ливан', kz: 'Ливан', en: 'Lebanon' },
  { code: 'LS', ru: 'Лесото', kz: 'Лесото', en: 'Lesotho' },
  { code: 'LR', ru: 'Либерия', kz: 'Либерия', en: 'Liberia' },
  { code: 'LY', ru: 'Ливия', kz: 'Ливия', en: 'Libya' },
  { code: 'LI', ru: 'Лихтенштейн', kz: 'Лихтенштейн', en: 'Liechtenstein' },
  { code: 'LT', ru: 'Литва', kz: 'Литва', en: 'Lithuania' },
  { code: 'LU', ru: 'Люксембург', kz: 'Люксембург', en: 'Luxembourg' },
  { code: 'MO', ru: 'Макао', kz: 'Макао', en: 'Macao' },
  { code: 'MG', ru: 'Мадагаскар', kz: 'Мадагаскар', en: 'Madagascar' },
  { code: 'MW', ru: 'Малави', kz: 'Малави', en: 'Malawi' },
  { code: 'MY', ru: 'Малайзия', kz: 'Малайзия', en: 'Malaysia' },
  { code: 'MV', ru: 'Мальдивы', kz: 'Мальдив аралдары', en: 'Maldives' },
  { code: 'ML', ru: 'Мали', kz: 'Мали', en: 'Mali' },
  { code: 'MT', ru: 'Мальта', kz: 'Мальта', en: 'Malta' },
  { code: 'MH', ru: 'Маршалловы Острова', kz: 'Маршалл аралдары', en: 'Marshall Islands' },
  { code: 'MQ', ru: 'Мартиника', kz: 'Мартиника', en: 'Martinique' },
  { code: 'MR', ru: 'Мавритания', kz: 'Мавритания', en: 'Mauritania' },
  { code: 'MU', ru: 'Маврикий', kz: 'Маврикий', en: 'Mauritius' },
  { code: 'YT', ru: 'Майотта', kz: 'Майотта', en: 'Mayotte' },
  { code: 'MX', ru: 'Мексика', kz: 'Мексика', en: 'Mexico' },
  { code: 'FM', ru: 'Микронезия', kz: 'Микронезия', en: 'Micronesia, Federated States of' },
  { code: 'MD', ru: 'Молдавия', kz: 'Молдова', en: 'Moldova, Republic of' },
  { code: 'MC', ru: 'Монако', kz: 'Монако', en: 'Monaco' },
  { code: 'MN', ru: 'Монголия', kz: 'Моңғолия', en: 'Mongolia' },
  { code: 'ME', ru: 'Черногория', kz: 'Черногория', en: 'Montenegro' },
  { code: 'MS', ru: 'Монтсеррат', kz: 'Монтсеррат', en: 'Montserrat' },
  { code: 'MA', ru: 'Марокко', kz: 'Марокко', en: 'Morocco' },
  { code: 'MZ', ru: 'Мозамбик', kz: 'Мозамбик', en: 'Mozambique' },
  { code: 'MM', ru: 'Мьянма', kz: 'Мьянма (Бирма)', en: 'Myanmar' },
  { code: 'NA', ru: 'Намибия', kz: 'Намибия', en: 'Namibia' },
  { code: 'NR', ru: 'Науру', kz: 'Науру', en: 'Nauru' },
  { code: 'NP', ru: 'Непал', kz: 'Непал', en: 'Nepal' },
  { code: 'NL', ru: 'Нидерланды', kz: 'Нидерланд', en: 'Netherlands' },
  { code: 'NC', ru: 'Новая Каледония', kz: 'Жаңа Каледония', en: 'New Caledonia' },
  { code: 'NZ', ru: 'Новая Зеландия', kz: 'Жаңа Зеландия', en: 'New Zealand' },
  { code: 'NI', ru: 'Никарагуа', kz: 'Никарагуа', en: 'Nicaragua' },
  { code: 'NE', ru: 'Нигер', kz: 'Нигер', en: 'Niger' },
  { code: 'NG', ru: 'Нигерия', kz: 'Нигерия', en: 'Nigeria' },
  { code: 'NU', ru: 'Ниуэ', kz: 'Ниуэ', en: 'Niue' },
  { code: 'NF', ru: 'Остров Норфолк', kz: 'Норфолк аралы', en: 'Norfolk Island' },
  { code: 'KP', ru: 'КНДР (Корейская Народно-Демократическая Республика)', kz: 'Солтүстік Корея', en: 'North Korea' },
  { code: 'MP', ru: 'Северные Марианские Острова', kz: 'Солтүстік Мариана аралдары', en: 'Northern Mariana Islands' },
  { code: 'NO', ru: 'Норвегия', kz: 'Норвегия', en: 'Norway' },
  { code: 'OM', ru: 'Оман', kz: 'Оман', en: 'Oman' },
  { code: 'PK', ru: 'Пакистан', kz: 'Пәкістан', en: 'Pakistan' },
  { code: 'PW', ru: 'Палау', kz: 'Палау', en: 'Palau' },
  { code: 'PA', ru: 'Панама', kz: 'Панама', en: 'Panama' },
  { code: 'PG', ru: 'Папуа — Новая Гвинея', kz: 'Папуа — Жаңа Гвинея', en: 'Papua New Guinea' },
  { code: 'PY', ru: 'Парагвай', kz: 'Парагвай', en: 'Paraguay' },
  { code: 'CN', ru: 'КНР (Китайская Народная Республика)', kz: 'Қытай', en: 'People\'s Republic of China' },
  { code: 'PE', ru: 'Перу', kz: 'Перу', en: 'Peru' },
  { code: 'PH', ru: 'Филиппины', kz: 'Филиппин', en: 'Philippines' },
  { code: 'PL', ru: 'Польша', kz: 'Польша', en: 'Poland' },
  { code: 'PT', ru: 'Португалия', kz: 'Португалия', en: 'Portugal' },
  { code: 'PR', ru: 'Пуэрто-Рико', kz: 'Пуэрто-Рико', en: 'Puerto Rico' },
  { code: 'QA', ru: 'Катар', kz: 'Катар', en: 'Qatar' },
  { code: 'CG', ru: 'Республика Конго', kz: 'Конго Республикасы', en: 'Republic of the Congo' },
  { code: 'GM', ru: 'Гамбия', kz: 'Гамбия', en: 'Republic of The Gambia' },
  { code: 'RE', ru: 'Реюньон', kz: 'Реюньон', en: 'Reunion' },
  { code: 'RO', ru: 'Румыния', kz: 'Румыния', en: 'Romania' },
  { code: 'RU', ru: 'Российская Федерация', kz: 'Ресей', en: 'Russian Federation' },
  { code: 'RW', ru: 'Руанда', kz: 'Руанда', en: 'Rwanda' },
  { code: 'BL', ru: 'Сен-Бартелеми', kz: 'Сен-Бартелеми', en: 'Saint Barthélemy' },
  { code: 'SH', ru: 'Острова Святой Елены, Вознесения и Тристан-да-Кунья', kz: 'Әулие Елена аралы', en: 'Saint Helena' },
  { code: 'KN', ru: 'Сент-Китс и Невис', kz: 'Сент-Китс және Невис', en: 'Saint Kitts and Nevis' },
  { code: 'LC', ru: 'Сент-Люсия', kz: 'Сент-Люсия', en: 'Saint Lucia' },
  { code: 'MF', ru: 'Сен-Мартен', kz: 'Сен-Мартен', en: 'Saint Martin (French part)' },
  { code: 'PM', ru: 'Сен-Пьер и Микелон', kz: 'Сен-Пьер және Микелон', en: 'Saint Pierre and Miquelon' },
  { code: 'VC', ru: 'Сент-Винсент и Гренадины', kz: 'Сент-Винсент және Гренадин аралдары', en: 'Saint Vincent and the Grenadines' },
  { code: 'WS', ru: 'Самоа', kz: 'Самоа', en: 'Samoa' },
  { code: 'SM', ru: 'Сан-Марино', kz: 'Сан-Марино', en: 'San Marino' },
  { code: 'ST', ru: 'Сан-Томе и Принсипи', kz: 'Сан-Томе және Принсипи', en: 'Sao Tome and Principe' },
  { code: 'SA', ru: 'Саудовская Аравия', kz: 'Сауд Арабиясы', en: 'Saudi Arabia' },
  { code: 'SN', ru: 'Сенегал', kz: 'Сенегал', en: 'Senegal' },
  { code: 'RS', ru: 'Сербия', kz: 'Сербия', en: 'Serbia' },
  { code: 'SC', ru: 'Сейшельские Острова', kz: 'Сейшель аралдары', en: 'Seychelles' },
  { code: 'SL', ru: 'Сьерра-Леоне', kz: 'Сьерра-Леоне', en: 'Sierra Leone' },
  { code: 'SG', ru: 'Сингапур', kz: 'Сингапур', en: 'Singapore' },
  { code: 'SX', ru: 'Синт-Мартен', kz: 'Синт-Мартен', en: 'Sint Maarten (Dutch part)' },
  { code: 'SK', ru: 'Словакия', kz: 'Словакия', en: 'Slovakia' },
  { code: 'SI', ru: 'Словения', kz: 'Словения', en: 'Slovenia' },
  { code: 'SB', ru: 'Соломоновы Острова', kz: 'Соломон аралдары', en: 'Solomon Islands' },
  { code: 'SO', ru: 'Сомали', kz: 'Сомали', en: 'Somalia' },
  { code: 'ZA', ru: 'ЮАР', kz: 'Оңтүстік Африка Республикасы', en: 'South Africa' },
  { code: 'KR', ru: 'Республика Корея', kz: 'Оңтүстік Корея', en: 'South Korea' },
  { code: 'SS', ru: 'Южный Судан', kz: 'Оңтүстік Судан', en: 'South Sudan' },
  { code: 'ES', ru: 'Испания', kz: 'Испания', en: 'Spain' },
  { code: 'LK', ru: 'Шри-Ланка', kz: 'Шри-Ланка', en: 'Sri Lanka' },
  { code: 'PS', ru: 'Государство Палестина', kz: 'Палестина аймақтары', en: 'State of Palestine' },
  { code: 'SD', ru: 'Судан', kz: 'Судан', en: 'Sudan' },
  { code: 'SR', ru: 'Суринам', kz: 'Суринам', en: 'Suriname' },
  { code: 'SJ', ru: 'Шпицберген и Ян-Майен', kz: 'Шпицберген және Ян-Майен', en: 'Svalbard and Jan Mayen' },
  { code: 'SE', ru: 'Швеция', kz: 'Швеция', en: 'Sweden' },
  { code: 'CH', ru: 'Швейцария', kz: 'Швейцария', en: 'Switzerland' },
  { code: 'SY', ru: 'Сирия', kz: 'Сирия', en: 'Syrian Arab Republic' },
  { code: 'TW', ru: 'Тайвань', kz: 'Тайвань', en: 'Taiwan, Province of China' },
  { code: 'TJ', ru: 'Таджикистан', kz: 'Тәжікстан', en: 'Tajikistan' },
  { code: 'TH', ru: 'Таиланд', kz: 'Тайланд', en: 'Thailand' },
  { code: 'MK', ru: 'Северная Македония', kz: 'Солтүстік Македония Республикасы', en: 'The Republic of North Macedonia' },
  { code: 'TL', ru: 'Восточный Тимор', kz: 'Тимор-Лесте', en: 'Timor-Leste' },
  { code: 'TG', ru: 'Того', kz: 'Того', en: 'Togo' },
  { code: 'TK', ru: 'Токелау', kz: 'Токелау', en: 'Tokelau' },
  { code: 'TO', ru: 'Тонга', kz: 'Тонга', en: 'Tonga' },
  { code: 'TT', ru: 'Тринидад и Тобаго', kz: 'Тринидад және Тобаго', en: 'Trinidad and Tobago' },
  { code: 'TN', ru: 'Тунис', kz: 'Тунис', en: 'Tunisia' },
  { code: 'TR', ru: 'Турция', kz: 'Түркия', en: 'Türkiye' },
  { code: 'TM', ru: 'Туркмения', kz: 'Түрікменстан', en: 'Turkmenistan' },
  { code: 'TC', ru: 'Теркс и Кайкос', kz: 'Теркс және Кайкос аралдары', en: 'Turks and Caicos Islands' },
  { code: 'TV', ru: 'Тувалу', kz: 'Тувалу', en: 'Tuvalu' },
  { code: 'UG', ru: 'Уганда', kz: 'Уганда', en: 'Uganda' },
  { code: 'UA', ru: 'Украина', kz: 'Украина', en: 'Ukraine' },
  { code: 'AE', ru: 'ОАЭ', kz: 'Біріккен Араб Әмірліктері', en: 'United Arab Emirates' },
  { code: 'GB', ru: 'Великобритания', kz: 'Ұлыбритания', en: 'United Kingdom' },
  { code: 'TZ', ru: 'Танзания', kz: 'Танзания', en: 'United Republic of Tanzania' },
  { code: 'US', ru: 'США', kz: 'Америка Құрама Штаттары', en: 'United States of America' },
  { code: 'UY', ru: 'Уругвай', kz: 'Уругвай', en: 'Uruguay' },
  { code: 'UZ', ru: 'Узбекистан', kz: 'Өзбекстан', en: 'Uzbekistan' },
  { code: 'VU', ru: 'Вануату', kz: 'Вануату', en: 'Vanuatu' },
  { code: 'VE', ru: 'Венесуэла', kz: 'Венесуэла', en: 'Venezuela' },
  { code: 'VN', ru: 'Вьетнам', kz: 'Вьетнам', en: 'Vietnam' },
  { code: 'VG', ru: 'Виргинские Острова (Великобритания)', kz: 'Британдық Виргин аралдары', en: 'Virgin Islands, British' },
  { code: 'VI', ru: 'Виргинские Острова (США)', kz: 'АҚШ-тың Виргин аралдары', en: 'Virgin Islands, U.S.' },
  { code: 'WF', ru: 'Уоллис и Футуна', kz: 'Уоллис және Футуна', en: 'Wallis and Futuna' },
  { code: 'EH', ru: 'САДР', kz: 'Батыс Сахара', en: 'Western Sahara' },
  { code: 'YE', ru: 'Йемен', kz: 'Йемен', en: 'Yemen' },
  { code: 'ZM', ru: 'Замбия', kz: 'Замбия', en: 'Zambia' },
  { code: 'ZW', ru: 'Зимбабве', kz: 'Зимбабве', en: 'Zimbabwe' },
];

const COUNTRY_BY_CODE = new Map(COUNTRIES.map((c) => [c.code, c]));

export function getCountryName(code: string, lang: LanguageCode): string {
  const country = COUNTRY_BY_CODE.get(code);
  if (!country) return code;
  return country[lang];
}

// localeCompare-based sorting over 200+ entries is expensive; the source list is
// static, so compute each language's sorted list once and reuse the reference.
const sortedCountriesCache = new Map<LanguageCode, { value: string; label: string }[]>();

export function getCountriesForLang(lang: LanguageCode): { value: string; label: string }[] {
  const cached = sortedCountriesCache.get(lang);
  if (cached) return cached;

  const list = COUNTRIES.map((c) => ({ value: c.code, label: c[lang] })).sort((a, b) =>
    a.label.localeCompare(b.label, lang === 'en' ? 'en' : 'ru')
  );
  sortedCountriesCache.set(lang, list);
  return list;
}
